export enum BillingsCargoTaxiBulkUpdateStatusRequestBillingStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
  REOPENED = "REOPENED",
}

export type BillingsCargoTaxiBulkUpdateStatusQueryParams = {
  billingIds: string[];
};

export type BillingsCargoTaxiBulkUpdateStatusRequestBody = {
  status: BillingsCargoTaxiBulkUpdateStatusRequestBillingStatus;
  comment?: string;
};

type BillingsCargoTaxiBulkUpdateStatusRequest = {
  status: BillingsCargoTaxiBulkUpdateStatusRequestBillingStatus;
  comment?: string;
  billingIds: string[];
};

export default BillingsCargoTaxiBulkUpdateStatusRequest;
